<template>
  <div class="login">
    <div class="logo">
      <img src="https://img.lessonplan.cn/IMG/Public/logo/competition-cover.png" alt="logo">
    </div>

    <div class="login-form">
      <input type="text" v-model="username" placeholder="电话/电子邮箱(phone/email)" class="username">
      <input type="password" v-model="password" placeholder="密码(password)" class="password">
      <a class="forgot-tips" @click="goForgot()">忘记密码(forgot)</a>
      <!-- <div class="radio-box">
        <div class="input-box" @click="isOnline='online'">
          <input type="radio" :checked="isOnline=='online'">online
        </div>
        <div class="input-box offline" @click="isOnline='offline'">
          <input type="radio" :checked="isOnline=='offline'">offline
        </div>
      </div> -->

      <button class="login-btn" @click="login()">登 录(login)</button>

      <!-- <button class="wx-login-btn pc" @click="wxloginForPC">微信登录</button>
      <button class="wx-login-btn mobile" @click="wxloginForMobile">微信登录</button> -->

      <div class="other">
        <span class="register-tips"><a @click="goRegister()">注册(register)</a></span>
        <a @click="returnBack()">返回(return)</a>
      </div>
    </div>
    <div class="wx-login-wrapper" v-show="isShowWxLoginWrapper" @click="isShowWxLoginWrapper = false">
      <div id="wx-login-qrcode"></div>
    </div>
  </div>
</template>

<script>
  import { addQueryString } from '../../util/url'
  import {
    PASSPORT_SERVER,
    PASSPORT_CLIENT_SERVER,
    WX_OPEN_SERVER
  } from '../../config/url'
  import {
    PC_APPID,
    M_APPID,
    SCOPE
  } from '../../config/wx'

  export default {
    name: 'login',
    props: {
      redirectURI: String,
    },
    data() {
      return {
        username: '',
        password: '',
        isShowWxLoginWrapper: false,
        isOnline: 'online'
      }
    },
    methods: {
      async login() {
        if (!this.username || !this.password) {
          return this.$message.warning('用户名和密码不能为空(The username and password cannot be empty)')
        }
        if (!this.isOnline) {
          return this.$message.warning('请先选择登录状态(Please select the login status first)')
        }

        const authRet = await this.$api.passport.auth({
          username: this.username,
          password: this.password
        })
        if (authRet.status !== 1) {
          return this.$message.warning('用户名或密码错误')
        } else {
          this.$api.account.recordUserStatus({
            FK_UserGuid: authRet.userGuid,
            LoginStatus: this.isOnline
          })
        }
        location.href = addQueryString(this.redirectURI, 'token', authRet.token)
      },

      wxloginForPC() {
        const wxApiRedirectURI = `${PASSPORT_SERVER}/wx/client_strict?redirectURI=${this.redirectURI}`

        this.isShowWxLoginWrapper = true

        // eslint-disable-next-line
        new WxLogin({
          id: 'wx-login-qrcode',
          appid: PC_APPID,
          scope: SCOPE,
          redirect_uri: (wxApiRedirectURI),
          fast_login: 1,
        })
      },

      wxloginForMobile() {
        const wxApiRedirectURI = `${PASSPORT_CLIENT_SERVER}/wx?redirectURI=${this.redirectURI}`
        location.href =
          `${WX_OPEN_SERVER}/connect/oauth2/authorize?appid=${M_APPID}&redirect_uri=${wxApiRedirectURI}&response_type=code&scope=snsapi_userinfo&state=strict#wechat_redirect`
      },

      returnBack() {
        window.location.href = this.redirectURI
      },

      goForgot() {
        this.$router.push({ name: 'tsinghua-forgot', query: { redirectURI: this.redirectURI } })
      },

      goRegister() {
        this.$router.push({ name: 'tsinghua-register', query: { redirectURI: this.redirectURI } })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .login {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 270px;
      margin-bottom: 30px;
    }

    h1 {
      font-size: 24px;
      color: #555;
      margin-top: 8px;
    }

    h3 {
      font-size: 17px;
      color: #555;
    }

    p {
      font-size: 15px;
      color: #777;
      margin-top: 12px;
      margin-bottom: 10px;
    }
  }

  .login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .forgot-tips {
      color: #666;
      font-size: 14px;
      text-align: right;
      width: 100%;
      margin-bottom: 10px;
    }

    .radio-box {
      width: 100%;
      font-size: 14px;
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      color: #666;

      .input-box {
        display: flex;
        align-items: center;
        cursor: pointer;

        &.offline {
          margin-left: 10px;
        }

        input {
          margin-right: 5px;
        }
      }
    }
  }

  .wx-login-btn {
    background: #fff;
    color: #1a7733;
    border: 1px solid #1a7733;
    margin-top: 12px;
    box-shadow: none;
    margin-top: 8px;

    &.pc {
      display: block;
    }

    &.mobile {
      display: none;
    }
  }

  .other {
    width: 270px;
    font-size: 14px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    color: #666;
  }


  /* PC端微信登录弹出二维码 */
  .wx-login-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.15);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  #wx-login-qrcode {
    width: 450px;
    height: 450px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 12px 24px 0 rgba(28, 31, 33, .1);
    border-radius: 5px;
  }

  /* 移动设备 */
  @media only screen and (max-width: 720px) {
    .wx-login-btn {
      &.mobile {
        display: block;
      }

      &.pc {
        display: none;
      }
    }
  }
</style>